import { type ImageDataDTO, type ImageFormat } from "~/domains/product/types/ProductDataDTO";
import { type SrpProductData } from "~/utils/models";

type Config = { imageFormat: ImageFormat | string };

export function getPrimaryImage(product: SrpProductData, config: Config): ImageDataDTO | undefined;
export function getPrimaryImage(images: ImageDataDTO[], config: Config): ImageDataDTO | undefined;

export function getPrimaryImage(source: SrpProductData | ImageDataDTO[], { imageFormat }: Config) {
  const images = "images" in source ? source.images : source;
  return images.filter((imgData) => imgData.imageType === "PRIMARY" && imgData.format === imageFormat)[0];
}
